import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface UserData {
    id: string;
    email: string;
    first_name: string;
    last_name: string;
    mobile_number: string;
    permissions: string[];
    primary_role: string;
    verified: boolean;
}

export interface AuthState {
    token: string | null;
    refreshToken: string | null;
    user: UserData | null;
    tokenExpiration: number | null;
}

const initialState: AuthState = {
    token: localStorage.getItem('token') || null,
    refreshToken: localStorage.getItem('refreshToken') || null,
    user: JSON.parse(localStorage.getItem('user') || 'null'),
    tokenExpiration: localStorage.getItem('tokenExpiration') ? Number(localStorage.getItem('tokenExpiration')) : null,
};

const authSlice = createSlice({
    name: 'auth',
    initialState,
    reducers: {
        setCredentials: (state, action: PayloadAction<{ access_token: string; refresh_token: string; expires_in: number; user: { data: UserData } }>) => {
            state.token = action.payload.access_token;
            state.refreshToken = action.payload.refresh_token;
            state.user = action.payload.user.data;
            state.tokenExpiration = Date.now() + action.payload.expires_in * 1000;

            localStorage.setItem('token', action.payload.access_token);
            localStorage.setItem('refreshToken', action.payload.refresh_token);
            localStorage.setItem('user', JSON.stringify(action.payload.user.data));
            localStorage.setItem('tokenExpiration', state.tokenExpiration.toString());
        },
        refreshToken: (state, action: PayloadAction<{ access_token: string; refresh_token: string; expires_in: number }>) => {
            try {
                state.token = action.payload.access_token;
                state.refreshToken = action.payload.refresh_token;
                state.tokenExpiration = Date.now() + action.payload.expires_in * 1000;

                localStorage.setItem('token', action.payload.access_token);
                localStorage.setItem('refreshToken', action.payload.refresh_token);
                localStorage.setItem('tokenExpiration', state.tokenExpiration.toString());
            } catch (error) {
                console.error('Error updating tokens:', error);
                state.token = null;
                state.refreshToken = null;
                state.tokenExpiration = null;

                localStorage.removeItem('token');
                localStorage.removeItem('refreshToken');
                localStorage.removeItem('tokenExpiration');
            }
        },
        logout: (state) => {
            state.token = null;
            state.refreshToken = null;
            state.user = null;
            state.tokenExpiration = null;

            localStorage.removeItem('token');
            localStorage.removeItem('refreshToken');
            localStorage.removeItem('user');
            localStorage.removeItem('tokenExpiration');
        },
    },
});

export const { setCredentials, refreshToken, logout } = authSlice.actions;
export default authSlice.reducer;


